/* global document window */

var ZXCVBN_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.2.0/zxcvbn.js';

function onLoad() {
  var script = document.createElement('script');
  script.src = ZXCVBN_SRC;
  script.type = 'text/javascript';
  script.async = true;
  var firstScriptNode = document.getElementsByTagName('script')[0];
  return firstScriptNode.parentNode.insertBefore(script, firstScriptNode);
};

module.exports = function loadZxcvbn() {
  if (window.attachEvent == null) {
    window.addEventListener('load', onLoad, false);
  }
  else {
    window.attachEvent('onload', onLoad);
  }
};
